import React from 'react';

import {type BaseIconProps, Icon} from '@packages/systems/spring';

/**
 * Credit card icon for displaying payment method information.
 * Uses currentColor for stroke to inherit text color from parent.
 *
 * @example
 * // Basic usage
 * <CreditCardIcon />
 *
 * // With color variant
 * <CreditCardIcon colorVariant="secondary" />
 */
export const CreditCardIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  (props, ref) => {
    return (
      <Icon size={24} colorVariant="blue" {...props} ref={ref}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M18.5 6.75H5.5C5.08579 6.75 4.75 7.08579 4.75 7.5V17.5C4.75 17.9142 5.08579 18.25 5.5 18.25H18.5C18.9142 18.25 19.25 17.9142 19.25 17.5V7.5C19.25 7.08579 18.9142 6.75 18.5 6.75Z"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path d="M4.75 10.75H19.25" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      </Icon>
    );
  }
);
